import axios from 'axios';
import { baseUrl } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';

const token = sessionStorage.getItem('token');
// -------------------------------------------------****Api Calls for Validation & Security Screen****-------------------------------------------------//

export const fetchBrokerOptionData = async (brokerId?: string | number) => {    // getApi to fetchData brokerOption in dropdown
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = brokerId ? `?broker_id=${brokerId}` : '';
        let url = `${baseUrl}api/ExdionAdmin/GetBrokersExdionAdmin${params}`;

        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching brokerData:', error);
        throw error;
    }
};

export const fetchBrokerFileUploadLImit = async (brokerId: any) => {    // getApi to fetch broker's file upload size limit 
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/ExdionAdmin/GetBrokerConfig?broker_id=${brokerId}`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching brokerData:', error);
        throw error;
    }
};

export const saveDataForBrokerIdS = async (selectedRow: any) => {    // saveApi for the brokerid's for upload file limit
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/ExdionAdmin/SaveBrokerConfig", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error creating_Or_updating broker file limit:", error);
        throw error;
    }
};
// --------------------------------------------------------------***********----------------------------------------------------------------------//

// -------------------------------------------------****Api Calls for Introduce Broker Screen****-------------------------------------------------//

export const fetchNewBrokerOptionData = async (brokerId?: string | number) => {    // getApi to fetchData brokerOption in introducebroker dropdown
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const params = brokerId ? `?broker_id=${brokerId}` : '';
        let url = `${baseUrl}api/ExdionAdmin/GetIntroduceBrokerData${params}`;

        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching brokerNewData:', error);
        throw error;
    }
};

export const fetchBrokerOptionById = async (brokerId?: string | number) => {    // getApi to fetchData by brokerId
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/ExdionAdmin/GetExdionAdminBrokerById?broker_id=${brokerId}`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching brokerNewData:', error);
        throw error;
    }
};

export const fetchBrokerLogoById = async (brokerId?: string | number) => {    // getApi to fetchData by brokerId
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/ExdionAdmin/GetBrokerLogoById?broker_id=${brokerId}`, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json"
            }
        });

        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error fetching brokerNewData:', error);
        throw error;
    }
};

export const saveDataForIntroduceBrokerForm = async (selectedRow: any) => {    // saveApi for the brokerid's for upload file limit
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/ExdionAdmin/AddOrUpdateBroker", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error creating_Or_updating broker form:", error);
        throw error;
    }
};

export const fetchAlllogoData = async () => {        // getApi to fetchlogs data
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/ExdionAdmin/getAllLogos`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the logo data:', error);
        throw error;
    }
};

export const saveDataForLogoData = async (payload: any) => {    // saveApi for the upload the logo 
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(
            baseUrl + "api/ExdionAdmin/SaveLogoObj",
            payload, 
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error in saving uploaded logo data:", error);
        throw error;
    }
};

// --------------------------------------------------------------***********----------------------------------------------------------------------//
